var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + (_vm.lang === '' ? '' : 'lang--' + _vm.lang)),attrs:{"id":"app"}},[_c('layout-home'),_c('component-control-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }